import { DefaultTheme } from 'styled-components';

const ThemeDefault: DefaultTheme = {
  background: '#17161E',
  cards: '#1F1E26',
  text: '#C4C4C4',
  lightText: '#FFFFFF',
  green: '#00A389',
  purple: '#AB54DB',
  black: '#000',
};

export default ThemeDefault;
